import {Component, OnInit} from '@angular/core';
import {SelectComponent} from 'web-shared';
import {ControlContainer, NgForm} from '@angular/forms';
import {ItemGroupQuery} from 'web-shared';
import {ManufacturingItemGroupEditModalComponent} from '../manufacturing-item-group-edit-modal/manufacturing-item-group-edit-modal.component';
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'mes-web-manufacturing-item-group-select',
  templateUrl: './manufacturing-item-group-select.component.html',
  viewProviders: [{provide: ControlContainer, useExisting: NgForm}],
  styles: [`
    :host {
      display: flex;
    }
  `],
})
export class ManufacturingItemGroupSelectComponent extends SelectComponent<ItemGroupQuery> implements OnInit {

  constructor() {
    super();
  }

  addNewGroup(searchTerm: string = null) {
    this.modalService.show(ManufacturingItemGroupEditModalComponent, {initialState: {entityName: searchTerm} as ManufacturingItemGroupEditModalComponent, class: 'modal-xl'}).onHide$.pipe(takeUntil(this.componentDestroyed)).subscribe((bsModalRef) => {
      const comp = bsModalRef.content as ManufacturingItemGroupEditModalComponent;
      this.setEntityId(comp.entityId);
    });
  }

  editExisting(groupQuery: ItemGroupQuery) {
    this.modalService.show(ManufacturingItemGroupEditModalComponent, {initialState: {entityId: groupQuery.Id} as ManufacturingItemGroupEditModalComponent, class: 'modal-xl'}).onHide$.pipe(takeUntil(this.componentDestroyed)).subscribe((bsModalRef) => {
      const comp = bsModalRef.content as ManufacturingItemGroupEditModalComponent;
      if (!this.multiple) {
        this.entityId = comp.entityId;
      }
    });
    this.setEntityId(this.entityId);
  }

  onSelectionChanged($event: ItemGroupQuery[] | ItemGroupQuery) {
    if (this.multiple) {
      const itemGroups = $event as ItemGroupQuery[];
      if (itemGroups && itemGroups.length) {
        this.entityIdsChange.emit(itemGroups.map(value => value.Id));
      } else {
        this.entityIdsChange.emit([]);
      }
    } else {
      this.setEntityId(($event as ItemGroupQuery)?.Id);
    }
  }
}
